import React from 'react';
import styles from './Tabs.module.css';
import { TabsVariant } from './Tabs';

export interface TabProps {
  children: React.ReactNode;
  isActive: boolean;
  onClick: () => void;
  variant?: TabsVariant;
  danger?: boolean;
  className?: string;
}

const Tab: React.FC<TabProps> = ({ 
  children, 
  isActive, 
  onClick, 
  variant = 'default',
  danger = false,
  className = ''
}) => {
  // Get base class based on variant
  const getVariantClass = () => {
    switch (variant) {
      case 'compact':
        return styles.tabCompact;
      case 'underline':
        return styles.tabUnderline;
      case 'pill':
        return styles.tabPill;
      default:
        return styles.tab;
    }
  };

  // Get active class based on variant
  const getActiveClass = () => {
    if (!isActive) return '';
    switch (variant) {
      case 'compact':
        return styles.tabCompactActive;
      case 'underline':
        return styles.tabUnderlineActive;
      case 'pill':
        return styles.tabPillActive;
      default:
        return styles.tabActive;
    }
  };

  const baseClass = getVariantClass();
  const activeClass = getActiveClass();
  const dangerClass = danger ? styles.tabDanger : '';

  return (
    <button
      className={`${baseClass} ${activeClass} ${dangerClass} ${className}`}
      onClick={onClick}
      type="button"
    >
      {children}
    </button>
  );
};

export default Tab;

